export default __webpack_public_path__ + "static/media/05.0891d924.jpg";